import { render, staticRenderFns } from "./InjectionTestCaseRequested.vue?vue&type=template&id=5132fef1&scoped=true&"
import script from "./InjectionTestCaseRequested.vue?vue&type=script&lang=js&"
export * from "./InjectionTestCaseRequested.vue?vue&type=script&lang=js&"
import style0 from "./InjectionTestCaseRequested.vue?vue&type=style&index=0&id=5132fef1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132fef1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5132fef1')) {
      api.createRecord('5132fef1', component.options)
    } else {
      api.reload('5132fef1', component.options)
    }
    module.hot.accept("./InjectionTestCaseRequested.vue?vue&type=template&id=5132fef1&scoped=true&", function () {
      api.rerender('5132fef1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/injection/InjectionTestCaseRequested.vue"
export default component.exports